"use client";

import { useContext } from "react";

import { QueueContext } from "../providers";

export const useQueue = () => useContext(QueueContext);
